import { Text } from "@chakra-ui/react";
import React from "react";

export const PasswordRequirements = (): JSX.Element => (
  <Text fontSize="0.8rem" color="black.500" mt="15px" mb="30px">
    Password must contain:
    <Text ml="10px">- a minimum of 8 characters</Text>
  </Text>
);
